<template>
    <layout
        :showuserinfo="false"
        :title="`Cukai Tanah: ${cukai.no_hm ?? 'Loading...'} `"
        :crumbs="crumbs"
    >
        <w-flex class="align-center justify-center" v-if="loading">
            <w-spinner />
        </w-flex>

        <z-page
            class=""
            title="Kemaskini Pengecualian"
            :append-button="true"
            v-if="!loading"
        >
            <w-flex :gap="3" column>
                <w-card bg-color="" class="table-hardcode">
                    <hakmilik :cukai="cukai" />
                </w-card>

                <w-card>
                    <w-form @submit.prevent="kemaskini">
                        <w-flex class="mt3">
                            <div class="xs6 mr3">
                                <w-input v-model="form.no_mknk" readonly>
                                    No. MMK</w-input
                                >
                            </div>
                            <div class="xs6 mr3">
                                <w-input v-model="namaPemilik" readonly
                                    >Nama Pemilik</w-input
                                >
                            </div>
                        </w-flex>
                        <w-flex class="mt3">
                            <div class="xs6 mr3">
                                <w-input v-model="tarikh_mula" readonly
                                    >Tarikh Mula</w-input
                                >
                            </div>
                              <div class="xs6 mr3">
                                <w-select
                                    label="Status"
                                    v-model="form.status"
                                    :items="status"
                                    :placeholder="[[stat]]"
                                    outline
                                    tile
                                />
                            </div>
                        </w-flex>

                        <div class="d-flex justify-end mt3">
                            <w-button class="my1 mr0" type="submit"
                                >Kemaskini
                            </w-button>
                        </div>
                    </w-form>
                </w-card>
            </w-flex>
        </z-page>
    </layout>
</template>

<script>
import ZResource from "@/Modules/z-resource";
import Hakmilik from "../Component/Hakmilik";
import { Inertia } from "@inertiajs/inertia";
import moment from "moment";

export default {
    extends: ZResource,
    props: {
        pengecualian: [Object],
    },
    components: {
        Hakmilik,
    },
    data() {
        var moment = require("moment");
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                {
                    label: "Pengecualian",
                    route: "/cukai-tanah/showPengecualian",
                },
                { label: "Kemaskini Pengecualian" },
            ],
            cukai: [],
            cukais: [],
            form: {
                hm_akaun_id:null,
                no_mknk: this.pengecualian.no_mknk,
                amaun: null,
                id: null,
                tarikh_tamat: null,
            },
            status: [
                { value: 1, label: "Aktif" },
                { value: 0, label: "Tidak Aktif" },
            ],
            tarikh_tamat: null,
            stat: null,
            tarikh_mula: null,
            loading: true,
            namaPemilik: null,
            keluasan: null,
        };
    },
    methods: {
        async kemaskini() {
            await axios({
                method: "put",
                url: `${this.apiBaseUrl}/cukai/pengecualian/${this.form.id}`,
                responseType: "json",
                data: this.form,
            })
                .then((e) => {
                    if (e.data.length > 0) {
                        console.log(e.data);
                    }
                })
                .finally((e) => {
                    Inertia.get("/cukai-tanah/showPengecualian");
                    //   this.getAmpunHasil();
                });
            // Inertia.post("/cukai-tanah/kemaskini-ampun-hasil",l);
        },
        async searchCukai(no_hm) {
            const l = {
                kategoriCarian: "1",
                formOption: "option1",
                barcode: no_hm,
                kodDaerah: "01",
            };
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/cari`,
                responseType: "json",
                data: l,
            })
                .then((e) => {
                    if (e.data.length > 0) {
                        this.cukai = e.data[0];
                        this.form.hm_akaun_id = e.data[0].id;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        async getData() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/pengecualian?no_hm=${this.pengecualian.no_hm}&limit=10&offset=0`,
                responseType: "json",
            }).then((e) => {
                const { data } = e.data;
                this.cukais = data[0];
                this.searchCukai(data[0].no_hm);
                
                if(data[0].tarikh_mula!=null){
                    this.tarikh_mula = moment(data[0].tarikh_mula).format(
                        "DD-MM-YYYY"
                    );
                }
                else{
                    this.form.tarikh_mula = null;
                }
                if(data[0].tarikh_tamat!=null){
                    this.form.tarikh_tamat = moment(data[0].tarikh_tamat).format(
                        "YYYY-MM-DD"
                    );
                }
                else{
                    this.form.tarikh_tamat=null;
                }

                this.form.amaun = data[0].amaun;
                this.form.id = data[0].id;
                (this.namaPemilik = data[0].pemiliks.map((d) => {
                    return d.nama;
                })),
                    // this.namaPemilik = e.data[0].pemiliks[0].nama;
                    (this.stat = data[0].status);
                this.keluasan = data[0].keluasan;
                this.tarikh_tamat = moment(e.data[0].tarikh_tamat).format(
                    "DD-MM-YYYY"
                );
            });
        },
    },
    watch: {},
    mounted() {
        this.getData();
        this.dialog.width = 500;
    },
};
</script>
<style>
::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgb(35, 71, 129);
    font-style: normal;
    opacity: 1; /* Firefox */
}
</style>
